import axios from 'axios'

import { Http } from '@/interfaces/http'

export const API_URL = process.env.REACT_APP_API_LOGISTICA_URL

const userString = localStorage.getItem('user')
const user = userString ? JSON.parse(userString) : {}

export const httpAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    IdUsuario: user?.userId
  }
})

export const API: Http = {
  get: async <T>(path: string, params?: Record<string, any>, config?: any) => {
    const { data } = await httpAxios
      .get(path, { ...config, params })
      .catch(error => {
        const errorDetails =
          error?.response?.data?.message ?? 'Solicitação não realizada!'
        return Promise.reject(errorDetails as Error)
      })
    return data as T
  },
  patch: async <T>(
    path: string,
    params?: Record<string, any>,
    config?: any
  ) => {
    const response = await httpAxios
      .patch(path, params instanceof FormData ? params : { ...params }, {
        ...config
      })
      .catch(error => {
        const errorDetails =
          error?.response?.data?.message ?? 'Solicitação não realizada!'
        return Promise.reject(errorDetails as Error)
      })
    return response.data as T
  },
  post: async <T>(path: string, params?: Record<string, any>, config?: any) => {
    const response = await httpAxios
      .post(path, params instanceof FormData ? params : { ...params }, {
        ...config
      })
      .catch(error => {
        const errorDetails =
          error?.response?.data?.message ?? 'Solicitação não realizada!'
        return Promise.reject(errorDetails as Error)
      })
    return response.data as T
  },
  put: async <T>(path: string, params?: Record<string, any>, config?: any) => {
    const response = await httpAxios
      .put(path, params instanceof FormData ? params : { ...params }, {
        ...config
      })
      .catch(error => {
        const errorDetails =
          error?.response?.data?.message ?? 'Solicitação não realizada!'
        return Promise.reject(errorDetails as Error)
      })
    return response.data as T
  },
  delete: async <T>(path: string, params?: any, config?: any) => {
    const response = await httpAxios
      .delete(path, { ...config, params })
      .catch(error => {
        const errorDetails =
          error?.response?.data?.message ?? 'Solicitação não realizada!'
        return Promise.reject(errorDetails as Error)
      })
    return response.data as T
  }
}
